/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

// SideTagMenu.jsx
import React, { useState, useEffect } from 'react';
import {fetchStockStrategyTags} from "../../api";

const SideTagMenu = ({ onTagSelect  }) => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    fetchStockStrategyTags()
      .then(data => {
        setTags(data.tags || []);
      })
      .catch(error => {
        console.error('Error fetching tags:', error);
      });
  }, []);
    const randomColor = (tag) => {
      const colors = ['#ffcdd2', '#bbdefb', '#c8e6c9', '#ffe0b2', '#d1c4e9', '#b2dfdb', '#f8bbd0', '#d7ccc8'];
      let hash = 0;
      for (let i = 0; i < tag.length; i++) {
        hash = tag.charCodeAt(i) + ((hash << 5) - hash);
      }
      const index = Math.abs(hash) % colors.length;
      return colors[index];
    };

  return (
    // <div style={styles.menu}>
    //   <h4>Filter Tags</h4>
    //   <button style={styles.clearButton} onClick={() => onTagSelect(null)}>Clear Filters</button>
    //   <ul style={styles.ul}>
    //     {tags.map((tag, i) => (
    //       <li style={styles.li} key={i}>
    //         <button style={styles.button} onClick={() => onTagSelect(tag)}>
    //         {tag}
    //       </button>
    //       </li>
    //     ))}
    //   </ul>
    // </div>
<div style={styles.menu}>
  <h4>Filter Tags</h4>
  <button style={styles.clearButton} onClick={() => onTagSelect(null)}>Clear Filters</button>
  <div style={styles.tagGrid}>
    {tags.map((tag, i) => (
      <button
        key={i}
        style={{
          ...styles.tagButton,
          backgroundColor: randomColor(tag),
        }}
        onClick={() => onTagSelect(tag)}
      >
        {tag}
      </button>
    ))}
  </div>
</div>
  );
};


// const styles = {
//   menu: {
//     width: '200px',
//     padding: '16px',
//     borderRight: '1px solid #ccc',
//     background: '#f1f1f1',
//   },
//   ul: {
//     listStyle: 'none',
//     padding: 0,
//   },
//   li: {
//     marginBottom: '8px',
//   },
//   button: {
//     width: '100%',
//     padding: '6px 10px',
//     background: '#007bff',
//     border: 'none',
//     color: 'white',
//     borderRadius: '4px',
//     cursor: 'pointer',
//   },
// };


// const styles = {
//   menu: {
//     padding: '20px',
//     width: '250px',
//     background: '#f9f9f9',
//     borderRight: '1px solid #ddd',
//     height: '60vh',
//     overflowY: 'auto',
//   },
//   tagContainer: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '8px',
//     marginTop: '10px',
//   },
//   tagButton: {
//     padding: '6px 10px',
//     borderRadius: '20px',
//     border: 'none',
//     background: '#e0e0e0',
//     cursor: 'pointer',
//     fontSize: '14px',
//     color: '#333',
//     transition: 'background 0.3s',
//   },
// };
const styles = {
  menu: {
    padding: '20px',
    width: '300px',
    background: '#f9f9f9',
    borderRight: '1px solid #ddd',
    height: '60vh',
    overflowY: 'auto',
  },
  tagGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',  // 3 equal columns
    gap: '8px',
    marginTop: '10px',
  },
  tagButton: {
    padding: '6px 8px',
    borderRadius: '20px',
    border: 'none',
    background: '#e0e0e0',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#333',
    transition: 'background 0.3s',
    whiteSpace: 'nowrap',   // so small tags don't wrap inside themselves
    textAlign: 'center',
  },
};

export default SideTagMenu;
